import './display.css';

export function Display({text}) {
  return (
    <p id="display">{text}</p>
  )
}
